/**
 * Campaign Configuration
 * Define campaign periods and settings here
 */

const CAMPAIGNS = {
  WELCOME: {
    id: "welcome",
    startDate: null,
    endDate: null,
  },
  RAMADAN: {
    id: "ramadan",
    startDate: new Date("2026-02-17"),
    endDate: new Date("2026-03-20"),
  },
};

/**
 * Get the currently active campaign based on current date
 * @returns {string} Campaign ID (e.g., "welcome", "ramadan")
 */
export const getActiveCampaign = () => {
  const now = new Date();
  now.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison

  // Check all campaigns except WELCOME
  for (const [key, campaign] of Object.entries(CAMPAIGNS)) {
    if (key === "WELCOME") continue;

    if (campaign.startDate && campaign.endDate) {
      const start = new Date(campaign.startDate);
      const end = new Date(campaign.endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      if (now >= start && now <= end) {
        return campaign.id;
      }
    }
  }

  // Default to WELCOME campaign
  return CAMPAIGNS.WELCOME.id;
};

export default CAMPAIGNS;
